import React, {useEffect,useState}from 'react'

import Map, { Marker, Popup } from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import Pin from './Pin';

import httpRequest from '../../../HttpService';

import endIcon from "./images/end_pin_sm.png";
import startIcon from "./images/start_pin_sm.png";
import driverIcon from "./images/pin_driver_sm.png";
import signIcon from "./images/pin_sign_sm.png";
import cameraIcon from "./images/pin_photo_sm.png";



const MapboxPanel = props => {
    //console.log("props.orderID is" + props.orderID);
       
    const [shPosition, setShPosition] = useState(null)
    const [cPosition, setCPosition] = useState(null)
    const [drPosition, setDrPosition] = useState(null)
    const [sigPosition, setSignPosition] = useState(null)
    const [zoom, setZoom] = useState(14)
    const [camPositions, setCamPositions] = useState([])

    const isValidCoord = (lat, lng) => Number.isFinite(lat) && Number.isFinite(lng);

    useEffect(() => {
        if (props.orderID) {
            var order = props.order;
            // Static shipper/consignee pins come from the order record already
            // fetched by tripInfo - getJobGPS is only needed for the driver's
            // live position below, so there's no reason to ask it for these too.
            if (!order || !isValidCoord(order.cLat, order.cLong)) {
                console.error("No usable consignee coordinates for order " + props.orderID);
            } else {
                setShPosition(isValidCoord(order.sLat, order.sLong) ? {lat:order.sLat, lng:order.sLong} : null);
                setCPosition({lat:order.cLat, lng:order.cLong});

                if (isValidCoord(order.sLat, order.sLong)) {
                    var dist = distance(order.sLat,order.sLong,order.cLat,order.cLong);
                    if(dist < 1)
                       setZoom(20);
                    else if(dist < 2)
                       setZoom(15);
                    else if(dist < 10)
                       setZoom(12);
                    else if(dist < 50)
                       setZoom(10);
                    else
                       setZoom(9);
                }
            }

            httpRequest.getJobGPS(props.orderID).then(response => {
                var gps = response.data;
                setDrPosition(gps && isValidCoord(gps.DriverLat, gps.DriverLong) ? {lat:gps.DriverLat, lng:gps.DriverLong}:null);
            }).catch(err => {
                console.error("getJobGPS failed", err);
            });

            if(props.order.delLat && props.order.delLong && props.order.delLat !== null && props.order.delLong!== null)
               setSignPosition({lat:props.order.delLat, lng:props.order.delLong});
        };
    },[props.orderID]);
    

    function distance(lat1, lon1, lat2, lon2) {
        if ((lat1 == lat2) && (lon1 == lon2)) {
            return 0;
        }
        else {
            var radlat1 = Math.PI * lat1/180;
            var radlat2 = Math.PI * lat2/180;
            var theta = lon1-lon2;
            var radtheta = Math.PI * theta/180;
            var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
            if (dist > 1) {
                dist = 1;
            }
            dist = Math.acos(dist);
            dist = dist * 180/Math.PI;
            dist = dist * 60 * 1.1515;
    
            dist = dist * 1.609344;            
            return dist;
        }
    }

    return(cPosition !== null) ?(
      <Map
        initialViewState={{longitude: cPosition.lng, latitude: cPosition.lat, pitch: 85, zoom: 10}}
            style={{width: "100%", height: 560}}
            mapStyle="mapbox://styles/mapbox/streets-v9"
            //mapboxAccessToken={"pk.eyJ1IjoiZGFycnlsd3UiLCJhIjoiY2t6MXF4eWQ2MW9sbDJvbXc1djlpd2tyNiJ9.-HSTj2T629xIl2NwM4UTZA"}
            mapboxAccessToken={process.env.REACT_APP_MAPBOX_API_KEY}
        >

        { shPosition && isValidCoord(shPosition.lat, shPosition.lng) &&
            <Marker longitude={shPosition.lng}  latitude={shPosition.lat}>
                <Pin pin_icon= {startIcon}/>
           </Marker>
        }

        <Marker longitude={cPosition.lng} latitude={cPosition.lat}>
            <Pin pin_icon= {endIcon}/>
       </Marker>

       { drPosition != null && isValidCoord(drPosition.lat, drPosition.lng) &&
             <Marker longitude={drPosition.lng} latitude={drPosition.lat}>
             <Pin pin_icon= {driverIcon}/>
        </Marker>
        }

        { sigPosition && isValidCoord(sigPosition.lat, sigPosition.lng) &&
             <Marker longitude={sigPosition.lng}  latitude={sigPosition.lat}>
             <Pin pin_icon= {signIcon}/>
        </Marker>
        }

        {Array.isArray(props.photoList) && props.photoList.map((item, index) => (
                item.gpsPoint && item.gpsPoint.points[0] &&item.gpsPoint.points[0].x && item.gpsPoint.points[0].y &&
                <Marker
                  key={item.imgID || index}
                  longitude={parseFloat(item.gpsPoint.points[0].y)}
                  latitude ={parseFloat(item.gpsPoint.points[0].x)}
                >
                  <Pin pin_icon= {cameraIcon}/>
                </Marker>
        ))}
           
    </Map>
    ) : <></>;

};
export default MapboxPanel;
